// About Page Section Navigation
export default function aboutPage() {
    'use strict';
    
    function initAboutPageNavigation() {
        const tabs = document.querySelectorAll('.gh-section-tab');
        const sections = document.querySelectorAll('.gh-section');
        
        if (!tabs.length || !sections.length) return;
        
        // Function to switch sections
        function switchSection(targetSection) {
            // Remove active class from all tabs and sections
            tabs.forEach(tab => tab.classList.remove('active'));
            sections.forEach(section => {
                section.classList.remove('active');
                // Reset animation
                section.style.animation = 'none';
                section.offsetHeight; // Trigger reflow
                section.style.animation = null;
            });
            
            // Add active class to selected tab and section
            const activeTab = document.querySelector(`[data-section="${targetSection}"]`);
            const activeSection = document.getElementById(`${targetSection}-section`);
            
            if (activeTab && activeSection) {
                activeTab.classList.add('active');
                activeSection.classList.add('active');
            }
        }
        
        // Add click handlers to tabs
        tabs.forEach(tab => {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                const targetSection = this.getAttribute('data-section');
                switchSection(targetSection);
                
                // Update URL hash without scrolling
                if (history.pushState) {
                    history.pushState(null, null, `#${targetSection}`);
                }
            });
        });
        
        // Handle initial hash or default to first section
        function handleInitialSection() {
            const hash = window.location.hash.slice(1);
            const validSections = ['mission', 'team', 'research'];
            
            if (hash && validSections.includes(hash)) {
                switchSection(hash);
            } else {
                // Default to mission section
                switchSection('mission');
            }
        }
        
        // Handle browser back/forward buttons
        window.addEventListener('popstate', function() {
            handleInitialSection();
        });
        
        // Initialize on load
        handleInitialSection();
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAboutPageNavigation);
    } else {
        initAboutPageNavigation();
    }
}